import React from 'react';
import { Button, Card, Col, Form, Icon, Input, message, Modal, Row, InputNumber, Select, Spin } from 'antd';
import { findCusWjwByEvent, createCusWjws, updateCusWjw } from "../../services/customization";
import { findEventSomples } from "../../services/evt";
import { connect } from "react-redux";





class CreateOrEditCscModal extends React.Component {
    constructor(props) {
        super(props);
        console.log(props)
        this.state = {
            formLoading: false,
            loading: true,
            data: null,
            events: []
        }
    }

    componentDidMount() {
        findEventSomples({happenStatus:6,eventMode:'BYREGISTER'}).then(res => {
            if (res.code == 200) {
                this.setState({ events: res.data })
            } else {
                message.error(res.msg,6);
            }
        }).catch(err => {
            message.warn("访问异常");
        })
        if (this.props.eventId) {
            findCusWjwByEvent({ eventId: this.props.eventId }).then(res => {
                if (res.code == 200) {
                    this.setState({
                        data: res.data,
                        loading: false,
                    })
                } else {
                    message.error(res.msg,6);
                }
            }).catch(err => {
                message.warn("访问异常");
            })
        } else {
            this.setState({
                loading: false,
            })
        }
    }

    componentWillUnmount() {

    }



    onSubmit = () => {
        this.props.form.validateFieldsAndScroll((error, values) => {
            if (!error) {
                this.changeFormLoading(true);
                let _fun = this.state.data ? updateCusWjw : createCusWjws;
                _fun(values).then(res => {
                    if (res.code == 200) {
                        message.info("操作成功!");
                        this.props.hide();
                        this.props.refTable();
                    } else {
                        message.error(res.msg,6);
                    }
                }).catch(err => {
                    message.warn("访问异常");
                }).finally(() => {
                    this.changeFormLoading(false)
                })
            } else {
                console.log('error', error, values);
            }
        });
    }

    changeFormLoading = (loading) => {
        if (this.mounted) {
            this.setState({
                formLoading: loading
            })
        }
    }





    render() {

        const { getFieldDecorator, getFieldValue, getFieldsValue } = this.props.form;
        const { eventId } = this.props;
        const { loading, data } = this.state;
        const formItemLayout = {
            labelCol: {
                xs: { span: 5 },
                sm: { span: 5 },
            },
            wrapperCol: {
                xs: { span: 17 },
                sm: { span: 17 },
            },
        };





        return (
            <Modal
                width={550}
                title={data ? '编辑规则' : '新增规则'}
                maskClosable={false}
                visible={true}
                onCancel={() => this.props.hide()}
                footer={[
                    <Button key="back" onClick={() => this.props.hide()}>
                        取消
                    </Button>,
                    <Button key="submit" type="primary" loading={this.state.formLoading} onClick={this.onSubmit}>
                        保存
                    </Button>,
                ]}
            >
                <Spin spinning={loading}>
                    {!loading &&
                        <Form>
                            <Form.Item
                                {...formItemLayout}
                                label="指定活动"
                            >
                                {getFieldDecorator(`eventId`, {
                                    initialValue: data ? data.eventId : '',
                                    rules: [{
                                        required: true, message: '请选择活动',
                                    }],
                                })(
                                    <Select disabled={data ? true : false} placeholder='请选择活动'>
                                        <Select.Option disabled={true} value={'0'}>全部活动</Select.Option>
                                        {
                                            this.state.events.map((obj, index) => (
                                                <Select.Option key={index} value={obj.id}>{obj.name}</Select.Option>
                                            ))
                                        }
                                    </Select>
                                )}
                            </Form.Item>
                            <Form.Item
                                {...formItemLayout}
                                label="可得总积分"
                            >
                                {getFieldDecorator(`totalStudyTime`, {
                                    initialValue: data ? data.totalStudyTime : 8,
                                    rules: [{
                                        required: true, message: '请填写',
                                    }],
                                })(
                                    <InputNumber
                                        style={{ width: '100%' }}
                                        min={0}
                                        precision={0}
                                    />
                                )}
                            </Form.Item>
                            <Form.Item
                                {...formItemLayout}
                                label="得分规则"
                            >
                                {getFieldDecorator(`type`, {
                                    initialValue: data ? data.type : '',
                                    rules: [{
                                        required: true, message: '请填写',
                                    }],
                                })(
                                    <Select >
                                        {
                                            Object.values(this.props.cmEnums.data.WjwRuleTypeEnum).map((item, index) => {
                                                return <Select.Option value={item.enumName.toString()} key={`csc-${index}`}>{item.enumDesc}</Select.Option>
                                            })
                                        }
                                    </Select>
                                )}
                            </Form.Item>
                            {data &&
                                <span style={{ display: 'none' }}>
                                    {
                                        getFieldDecorator('id', {
                                            initialValue: data.id,
                                            rules: [
                                                { required: true, message: '必填项' },
                                            ],
                                        })(
                                            <Input />
                                        )
                                    }
                                </span>}


                        </Form>
                    }
                </Spin>
            </Modal>
        )
    }
}


CreateOrEditCscModal.contextTypes = {}

CreateOrEditCscModal.defaultProps = {
    refTable: () => null
}

CreateOrEditCscModal.propTypes = {}

const mapStateToPorps = state => {
    const cmEnums = state.cmEnums;
    return { cmEnums };
};
export default connect(mapStateToPorps)(Form.create()(CreateOrEditCscModal));



// WEBPACK FOOTER //
// ./src/containers/usersfrom/CreateOrEditCscModal.jsx